import React, { useState, useEffect } from "react";
import { getDatabase, ref, onValue } from "firebase/database";
import app from "../../../firebaseConfig";

function ProteccionBarra({ children }) {
  const [accesoPermitido, setAccesoPermitido] = useState(false);
  const [mostrarDialogo, setMostrarDialogo] = useState(false);
  const [claveInput, setClaveInput] = useState("");
  const [clavesPermitidas, setClavesPermitidas] = useState([]);
  const [error, setError] = useState("");

  useEffect(() => {
    const db = getDatabase(app);
    const adminRef = ref(db, "nature/Awoo/Control/Seguridad/Admin");
    const barraRef = ref(db, "nature/Awoo/Control/Seguridad/Claves/Barra");

    // Escuchar ambas claves
    onValue(adminRef, (snapshot) => {
      const adminClave = snapshot.val();
      onValue(barraRef, (snapshot2) => {
        const barraClave = snapshot2.val();
        const claves = [adminClave, barraClave];
        setClavesPermitidas(claves);
        validarClaveGuardada(claves);
      });
    });
  }, []);

  const validarClaveGuardada = (claves) => {
    const claveGuardada = localStorage.getItem("adminKey");
    if (claves.includes(claveGuardada)) {
      setAccesoPermitido(true);
    } else {
      setMostrarDialogo(true);
    }
  };

  const handleIngresarClave = () => {
    if (clavesPermitidas.includes(claveInput)) {
      localStorage.setItem("adminKey", claveInput);
      setAccesoPermitido(true);
      setMostrarDialogo(false);
      setError("");
    } else {
      setError("❌ Clave incorrecta. Intenta nuevamente.");
    }
  };

  if (!accesoPermitido) {
    return (
      mostrarDialogo && (
        <div style={{
          position: "fixed", top: 0, left: 0, width: "100vw", height: "100vh",
          backgroundColor: "rgba(0,0,0,0.8)", display: "flex",
          justifyContent: "center", alignItems: "center", zIndex: 9999
        }}>
          <div style={{
            background: "#222", padding: "30px", borderRadius: "10px",
            maxWidth: "400px", width: "90%", textAlign: "center", boxShadow: "0 0 20px #000"
          }}>
            <h2 style={{ color: "#fff", marginBottom: "20px" }}>🔒 Acceso Restringido</h2>
            <input
              type="password"
              placeholder="Ingresa la clave"
              value={claveInput}
              onChange={(e) => setClaveInput(e.target.value)}
              style={{
                width: "100%", padding: "10px", marginBottom: "10px",
                borderRadius: "5px", border: "1px solid #555", backgroundColor: "#111", color: "#fff"
              }}
              onKeyDown={(e) => e.key === "Enter" && handleIngresarClave()}
            />
            <button
              onClick={handleIngresarClave}
              style={{
                padding: "10px 20px", backgroundColor: "#4CAF50",
                color: "#fff", fontWeight: "bold", border: "none", borderRadius: "5px", cursor: "pointer"
              }}
            >
              ✅ Ingresar
            </button>
            {error && <p style={{ color: "red", marginTop: "10px" }}>{error}</p>}
          </div>
        </div>
      )
    );
  }

  return <>{children}</>;
}

export default ProteccionBarra;
